export default "__VITE_ASSET__48103d70__"